import { defineComponent as _defineComponent } from 'vue'
import {
  computed, watch,
  ref, onMounted, getCurrentInstance,
} from "vue";
import {applyMaskToValue} from "@/components/forms/payout/forms/inputs/input-mask";



export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutMaskedInput',
  props: {
  value: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  mask: {
    type: String,
    default: 'DDDD/DD/DD'
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;




const formatValue = (value: string) => {
  return applyMaskToValue(value, props.mask);
}

const instance = ref(null);

const inputValue = computed({
  get() {
    return formatValue(props.value);
  },
  set(value) {
    emit('input', formatValue(value), value)
    if (instance.value) {
      instance.value.$forceUpdate();
    }
  }
})

watch(() => props.value, (value) => {
  refreshValue();
})

const refreshValue = () => {
  if (props.value && (props.value.length > 0)) {
    const val = formatValue(props.value);
    if ((val.length > 0) && (val !== props.value)) {
      emit('input', val, props.value);
    }
  }
}

onMounted(() => {
  instance.value = getCurrentInstance().proxy;
  refreshValue();
})

return { __sfc: true,props, emit, formatValue, instance, inputValue, refreshValue, computed, watch, ref, onMounted, getCurrentInstance, applyMaskToValue }
}

})